import { Injectable } from '@angular/core';
import { SessionContextService, SessionStorageService } from '@core/services/common';
import { Utils } from './utils.helper';
import { LOCAL_STORAGE_KEY, nyushoGridConfig, nyushoPositionDialog, SESSION_STORAGE_KEY, tsushoGridConfig } from '@core/configs';
import { ScreenConfigService } from '@core/services/apis/screen-config.service';
import { buildGroupDropdown } from '@modules/check-sheet/helper/check-sheet-data.helper';
import { lastValueFrom } from 'rxjs';
import { OfficeService } from '@core/services/apis/office.service';
import { LeaveType } from '@core/models/enums';
@Injectable({
  providedIn: 'root'
})
export class CheckSheetSettingHelper { 
  isNyuSho: boolean;
  constructor(
    private sessionStorageService: SessionStorageService,
    private sessionContextService: SessionContextService,
    private screenConfigService: ScreenConfigService,
    private officeService: OfficeService,
  ) {
    let officeSelected = this.sessionContextService.getOfficeSelected<any>();
    this.isNyuSho = Utils.isNyusho(officeSelected.officeType);
  }

  filterGroupByUnit(unitSelected: any[], sessionGroupData: any[]) {
    // Nếu không có gì được chọn thì hiển thị tất cả
    if (Utils.isNullOrEmpty(unitSelected) || unitSelected.length === 0) {
      return sessionGroupData;
    }

    let filtered: any[] = [];

    for (const selected of unitSelected) {
      if (selected?.includes('-')) {
        // Trường hợp value có dạng "block-unit"
        const [blockcd, unitcd] = selected.split('-');

        const matchItems = sessionGroupData.filter((gr: any) => {
          const [grBlockCd, grUnitCd] = gr?.value?.split('-');
          return blockcd === grBlockCd && unitcd === grUnitCd;
        });

        filtered = [...filtered, ...matchItems];
      } else {
        // Trường hợp chỉ chọn block
        const matchItems = sessionGroupData.filter((gr: any) => {
          const [grBlockCd] = gr?.value?.split('-');
          return selected === grBlockCd;
        });

        filtered = [...filtered, ...matchItems];
      }
    }

    return filtered.filter(
      (v, i, a) => a.findIndex(t => t.value === v.value) === i
    );
  }

  filterBathRoomByUnit(unitSelected: any[], sessionBathRoomData: any[]) {
    // Nếu không có gì được chọn thì hiển thị tất cả
    if (Utils.isNullOrEmpty(unitSelected) || unitSelected.length === 0) {
      return sessionBathRoomData;
    }

    let filtered: any[] = [];

    for (const selected of unitSelected) {
      if (selected?.includes('-')) {
        // Trường hợp value có dạng "block-unit"
        const [blockcd, unitcd] = selected.split('-');

        const matchItems = sessionBathRoomData.filter((br: any) => {
          const [BrBlockcd, BrUnitcd] = br?.value?.split('|');
          return blockcd === BrBlockcd && unitcd === BrUnitcd;
        });

        filtered = [...filtered, ...matchItems];
      } else {
        // Trường hợp chỉ chọn block
        const matchItems = sessionBathRoomData.filter((br: any) => {
          const [BrBlockcd] = br?.value?.split('|');
          return selected === BrBlockcd;
        });

        filtered = [...filtered, ...matchItems];
      }
    }

    let bathRoomList = filtered.filter(
      (v, i, a) => a.findIndex(t => t.value === v.value) === i
    );

    bathRoomList = [
      { name: "　", value: "" },
      ...bathRoomList
    ]

    return bathRoomList;
  }

  async getBlockAndUnitInfo() {
    let displayUnits = this.sessionStorageService.getSessionData(LOCAL_STORAGE_KEY.blockAndUnitData) || [];
    if (!displayUnits || displayUnits.length <= 0) {
      const res: any = await lastValueFrom(this.officeService.getBlockAndUnitInfo());
      if (res?.status === 200 && res?.result?.isSuccessStatusCode) {
        let resData = JSON.parse(res?.result?.json);
        if (resData) {
          let dropdownData: any[] = [];
          resData?.BlockList.forEach((block:any) => {
            if (block?.blockcd !== '91') {
              // push block vào list
              dropdownData.push({ name: block?.blocknm, value: block?.blockcd });
              // push các unit thuộc block
              resData?.UnitList
                .filter((unit:any) => unit?.blockcd === block?.blockcd)
                .forEach((unit:any) => {
                  dropdownData.push({ name:block?.blocknm + " " + unit?.unitnm, value: block?.blockcd + "-" + unit?.unitcd });
                }
              );
            }
          });
          displayUnits = [ 
            ...dropdownData
          ];
          this.sessionStorageService.setSessionData(LOCAL_STORAGE_KEY.blockAndUnitData, displayUnits);
        }
      }
    }
    return displayUnits;
  }
  
  async getGroupInfo() {
    let displayGroups = this.sessionStorageService.getSessionData(LOCAL_STORAGE_KEY.groupData) || [];
    if (!displayGroups || displayGroups.length <= 0) {
      const res: any = await lastValueFrom(this.officeService.getGroupInfo());
      if (res?.status === 200 && res?.result?.isSuccessStatusCode) {
        let resData = JSON.parse(res?.result?.json);
        if (resData) {
          displayGroups = buildGroupDropdown(resData);
          this.sessionStorageService.setSessionData(LOCAL_STORAGE_KEY.groupData, displayGroups);
        }
      }
    }
    return displayGroups;
  }
  
  handleHeaderColMoiSture(currentHeaders: any[]) {
    if (!currentHeaders || currentHeaders.length <= 0) {
      return [];
    }
    //Get snack field
    let colSnackMoi = currentHeaders?.find(f => f.field == 'snack');
    
    //Create temp objcd snack moisture
    let snackMoisture = {
      width: "5%",
      items: [{ title: 'おやつ水分' }],
      title: 'おやつ水分',
      field: 'snack_moisture',
      headerName: "おやつ水分",
      visible: colSnackMoi.hasSubHeader == null ? true : colSnackMoi.hasSubHeader
    };
    const currentSnacklMoisture = currentHeaders?.find(crhd => crhd.field === "snack_moisture");
    if (!currentSnacklMoisture) {
      let indexOfSnack = currentHeaders.indexOf(colSnackMoi);
      currentHeaders.splice(indexOfSnack + 1, 0, snackMoisture);
    }
    return currentHeaders;
  }

  filterReasonLeave(dataFilter: any[], settingData: any = null) {
    if (!dataFilter) return [];
    if (!settingData) {
      try {
        settingData = this.getCurrentOfficeScreenSettings();
      } catch (error) {
        settingData = null;
      }
    }
    const isShowReasonLeave = settingData?.headers?.find((x: any) => x?.field === "leave_reason")?.visible;
    dataFilter?.map((x: any) => {
      if (x?.index?.value === LeaveType.leave) {
        if (isShowReasonLeave === false) {
          x.notice_list = [];
        }
      }
      return x;
    });
    return dataFilter;
  }

  private getCurrentOfficeScreenSettings(): any {
    const officeCd = this.getSelectedOfficeCd();
    if (!officeCd) return null;

    const allSettings = this.getAllScreenSettings();
    const officeSettings = allSettings[officeCd];
    return this.isPlainObject(officeSettings) ? officeSettings : null;
  }

  private getSelectedOfficeCd(): string | null {
    const officeInfo = sessionStorage.getItem(SESSION_STORAGE_KEY.selectedOfficeIdentity);
    if (!officeInfo) return null;

    try {
      return JSON.parse(officeInfo)?.officeCd ?? null;
    } catch {
      return null;
    }
  }

  private getAllScreenSettings(): Record<string, any> {
    const allSettingsInfo = localStorage.getItem(LOCAL_STORAGE_KEY.settingDialog);
    if (!allSettingsInfo) return {};

    try {
      const parsedSettings = JSON.parse(allSettingsInfo);
      return this.isPlainObject(parsedSettings) ? parsedSettings : {};
    } catch {
      return {};
    }
  }

  private isPlainObject(value: unknown): value is Record<string, any> {
    return !!value && typeof value === 'object' && !Array.isArray(value);
  }

  processReasonLeaveColumn(currentHeaders: any[]) {
    if (!currentHeaders || currentHeaders.length <= 0) {
      return [];
    }
    const reasonLeave = {
      field: 'leave_reason',
      headerName: "中止理由",
      visible: true
    };
    const currentReasonLeave = currentHeaders?.find(crhd => crhd.field === "leave_reason");
    if (!currentReasonLeave) {
      currentHeaders.push(reasonLeave);
    }
    return currentHeaders;
  }

  processMealMoistureColumn(currentHeaders: any[]) {
    if (!currentHeaders || currentHeaders.length <= 0) {
      return [];
    }
    if (this.isNyuSho) {
      const colMeal = currentHeaders?.find(f => f.field == 'meal');
      const mealMoisture = nyushoGridConfig?.header?.find((m:any)=> m.field == "meal_moisture");
      const currentMealMoisture = currentHeaders?.find(crhd => crhd.field === "meal_moisture");
      if (!currentMealMoisture) {
        let idxMeal = currentHeaders.indexOf(colMeal);
        currentHeaders.splice(idxMeal + 1, 0, mealMoisture);
      }
      // sắp xếp lại vị trí config để hiện thị switch btn trên dialog
      let sortedHeader:any[] = [], findHeader;
      nyushoPositionDialog.forEach(phd => {
        findHeader = currentHeaders.find(ch => ch.field === phd.field);
        if (findHeader) {
          sortedHeader.push(findHeader);
        }
      });

      if (sortedHeader.length > 0) currentHeaders = sortedHeader;
      
    }
    return currentHeaders;
  }
}
